import { seoConfig } from "./seoConfig.js";

// Convierte una ruta relativa (o una URL ya absoluta) en una URL absoluta
// usando el dominio de producción configurado en seoConfig.siteUrl.
// Se usa tanto para canonical/OG/Twitter como para JSON-LD.
export function resolveSiteUrl(pathOrUrl) {
  if (!pathOrUrl) return `${seoConfig.siteUrl}/`;
  try {
    return new URL(pathOrUrl, seoConfig.siteUrl).toString();
  } catch {
    return `${seoConfig.siteUrl}/`;
  }
}

export default resolveSiteUrl;
